import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ExerciseTargetForm from '../../../components/forms/ExerciseTargetForm';
import { useExerciseTargetApi } from '../../../hooks/useExerciseTargetApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ExerciseTargetDTO } from '../../../services/apiClient';

const ExerciseTargetEdit: React.FC = () => {
  const { getById, edit, isLoading } = useExerciseTargetApi();
  const [entityData, setEntityData] = useState<ExerciseTargetDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Exercise Targets', href: '/admin/exercisetargets' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Exercise Target data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/exercisetargets');
    } catch (error) {
      console.error('Error updating Exercise Target:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/exercisetargets"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ExerciseTarget.Edit'
    >
        {entityData ? (
          <ExerciseTargetForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/exercisetargets')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ExerciseTargetEdit;